__turbopack_context__.v({
  "link": "LanguageSwitcher-module__psbpAa__link",
  "linkFooter": "LanguageSwitcher-module__psbpAa__linkFooter",
  "list": "LanguageSwitcher-module__psbpAa__list",
  "listFooter": "LanguageSwitcher-module__psbpAa__listFooter",
  "nav": "LanguageSwitcher-module__psbpAa__nav",
  "navFooter": "LanguageSwitcher-module__psbpAa__navFooter",
});
